function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-tile-grid\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.68,32.83H13.32a1.07,1.07,0,1,1,0-2.13H26.68a1.07,1.07,0,1,1,0,2.13Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,17.57a3.95,3.95,0,1,1,3.95-4A4,4,0,0,1,20,17.57Zm0-6.4a2.45,2.45,0,1,0,2.45,2.45A2.45,2.45,0,0,0,20,11.17Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.52,23.59a.77.77,0,0,1-.67-.4,6.59,6.59,0,0,0-11.7,0,.75.75,0,1,1-1.33-.7,8.09,8.09,0,0,1,14.36,0,.76.76,0,0,1-.32,1A.84.84,0,0,1,26.52,23.59Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.44,39.3H11.56a6.83,6.83,0,0,1-6.82-6.82v-25A6.83,6.83,0,0,1,11.56.7H28.44a6.83,6.83,0,0,1,6.82,6.82v25A6.83,6.83,0,0,1,28.44,39.3ZM11.56,3A4.58,4.58,0,0,0,7,7.52v25a4.58,4.58,0,0,0,4.57,4.57H28.44A4.58,4.58,0,0,0,33,32.48v-25A4.58,4.58,0,0,0,28.44,3Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20,26.19A10.43,10.43,0,1,1,30.42,15.77,10.43,10.43,0,0,1,20,26.19Zm0-18.6a8.18,8.18,0,1,0,8.17,8.18A8.19,8.19,0,0,0,20,7.59Z",
  fill: "#231f20"
});

function SvgCmsTileGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cms-tile-grid_svg__cms-tile-grid_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsTileGrid;